export enum StepId {
  FileUpload = 'fileUpload',
  ManifestInfo = 'manifestInfo',
  PackageMetadata = 'packageMetadata',
  DeviceCompatibility = 'deviceCompatibility',
  Distribution = 'distribution',
  ReleaseNotes = 'releaseNotes',
  Summary = 'summary'
}

export const STEP_CONFIG = [
  { id: StepId.FileUpload, label: 'File upload' },
  { id: StepId.ManifestInfo, label: 'Manifest information' },
  { id: StepId.PackageMetadata, label: 'Package metadata' },
  { id: StepId.DeviceCompatibility, label: 'Device compatibility' },
  { id: StepId.Distribution, label: 'Distribution' },
  { id: StepId.ReleaseNotes, label: 'Release notes' },
  { id: StepId.Summary, label: 'Summary' }
];
